<template>
  <div>

    <div v-if="showReader">
      <v-card>
        <qrcode-stream @decode="onDecode" @init="onInit">
          <div class="loading-indicator" v-if="loading">
            QR code reader loading...
          </div>
        </qrcode-stream>
      </v-card>
    </div>
    <div v-if="!showReader">
      <v-layout justify-center>
      <h3>QR Code Reader will appear here when enabled</h3>
      </v-layout>
    </div>

    <v-card>
      <v-card-title>Reader Debug</v-card-title>
      <p>Reader Error: {{ error }}</p>
      <p>Reader Last Result: <b>{{ result }}</b></p>
    </v-card>

    <v-layout justify-center>
      <v-btn @click="showReader = !showReader">Toggle barcode reader on and off</v-btn>
    </v-layout>

  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {

  components: { QrcodeStream },
  data () {
    return {
      loading: false,
      showReader: false,
      result: '',
      error: ''
    }
  },
  methods: {
    onDecode (result) {
      console.log('ondecode', result)
      this.result = result
      this.showReader = false
    },

    async onInit (promise) {
      this.loading = true
      this.result = ''

      try {
        await promise
        console.log('oninit promoise complete')
      } catch (error) {
        console.log('oninit catch', error)
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
